import {sanitizeForLogging} from './sanitize';

export const CONSOLE_MARKER = '[LoggingProvider]';

const CONSOLE_METHODS = {
    breadcrumb: 'info',
    disabled: 'error',
    invalid: 'warn',
    queued: 'error',
    suppressed: 'warn'
};

export function reportToConsole ( status, payload, options = {} ) {
    const detail = options.detail ? `: ${options.detail}` : '';
    const label = `${CONSOLE_MARKER}[Sentry ${status}${detail}]`;
    const method = options.level || CONSOLE_METHODS[status] || 'error';

    try {
        if ( typeof console !== 'undefined' && typeof console[method] === 'function' ) {
            console[method]( label, sanitizeForLogging( payload ) );
        }
    }
    catch ( error ) {
        // Diagnostics must never interrupt an application workflow.
    }
}

export function isProviderConsoleBreadcrumb ( breadcrumb ) {
    return !!breadcrumb && breadcrumb.category === 'console' &&
        typeof breadcrumb.message === 'string' && breadcrumb.message.indexOf( CONSOLE_MARKER ) === 0;
}
